import { useState } from "react";

export const useVideoWindow = () => {
	const [videoWindowVisible, setVideoWindowVisible] = useState<boolean>(false);

	return { videoWindowVisible, setVideoWindowVisible };
}
